export const EMAIL_MATCH_REGEXP =
    /^[\w!#$%&'*+=?`{|}~^-]+(?:\.[\w!#$%&'*+=?`{|}~^-]+)*@(?:[a-zA-z0-9-]+\.)+[A-za-z]{2,10}$/;
